import type { SubscriptionDetails } from '@models/subscriptions';
import { apiClient } from '@api/client';

export type GetSubscriptionDetailsParams = {
  subscriptionId: string;
  /** Bounds the scan of the created_at-partitioned period/event tables — required by the API. */
  subscriptionCreatedAt: string;
};

export async function getSubscriptionDetails({
  subscriptionId,
  subscriptionCreatedAt,
}: GetSubscriptionDetailsParams): Promise<SubscriptionDetails> {
  const { data } = await apiClient.get<SubscriptionDetails>(
    `/dashboard-subscriptions/${encodeURIComponent(subscriptionId)}/details`,
    { params: { subscriptionCreatedAt } },
  );
  return data;
}
